import { Modal, ModalTitle, ModalContent, ModalFooter, Button } from '@utahdts/utah-design-system';
import WaterSystemSearchInput from './WaterSystemSearchInput';
import { useWaterSystemSearchModal } from './WaterSystemSearchModalContext'
import './WaterSystemSearchModal.css';

const WaterSystemSearchModal = ({ selectedWaterSystem, setSelectedWaterSystem }) => {
  const { showSystemSelectModal, setShowSystemSelectModal } = useWaterSystemSearchModal();

  return (
    <>
    {showSystemSelectModal && (
      <div className="utah-design-system">
        <Modal
          className="modal--medium"
          onClose={() => setShowSystemSelectModal(false)}
          onEscape={() => setShowSystemSelectModal(false)}
        >
          <ModalTitle>Select a Water System</ModalTitle>
          <ModalContent id="WS-SearchModal-Content">
            <WaterSystemSearchInput 
              setShowSystemSelectModal={setShowSystemSelectModal}
              selectedWaterSystem={selectedWaterSystem}
              setSelectedWaterSystem={setSelectedWaterSystem}
            />
          </ModalContent>
          <ModalFooter id="WS-SearchModal-Footer">
            <Button
              onClick={() => {
                setShowSystemSelectModal(false);
              }}
            >Cancel</Button>
          </ModalFooter>
        </Modal>
      </div>
    )}
    </>
  );
};

export default WaterSystemSearchModal;
